import Vue from 'vue'
import axios from '@plugins/axios'
import store from '@state/store'
import config from '@src/app.config'
const env = config.env
const appConfig = config[env]

export const state = {
  cached: {},
  pronostics: {
    results: []
  },
  projects: {},
  forecasters: {
    results: []
  },
  loadingPronostics: false,
  isSubmitting: false,
  uploadResult: ''
}

export const getters = {
  pronostics: state => state.pronostics,
  loadingPronostics: state => state.loadingPronostics,
  isSubmitting: state => state.isSubmiting,
  findPronostic: state => (id) => state.pronostics.results.find( project => project.id === id),
  projects: state => state.projects,
  forecasters: state => state.forecasters,
  uploadResult: state => state.uploadResult,
}

export const mutations = {
  SET_CACHE(state, { key, value }) {
    Vue.set(state, key, value)
  },
  SET_PRONOSTICS(state, data) {
    state.pronostics = data
  },
  SET_LOADING(state, loading) {
    state.loadingPronostics = loading
  },
  SET_SUBMIT(state, data){
    state.isSubmitting = data
  },
  SET_PROJECTS(state, data) {
    state.projects = data
  },
  SET_PROJECT_FORECASTERS(state, data) {
    state.forecasters = data
  }
}

export const actions = {
  fetchPronostics({ commit }, query) {
    store.dispatch('utils/loaderMessage', 'Cargando pronósticos...' )
    commit('SET_LOADING', true)
    axios.get(appConfig.server_url + `/projects_management/project/?${query}`)
      .then(resp => {
        if (resp.status === 200) {
          commit('SET_PRONOSTICS', resp.data)
          commit('SET_LOADING', false)
          store.dispatch('utils/loaderMessage', '' )
        }
      })
      .catch(() => {
        commit('SET_LOADING', false)
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error consultando pronósticos.' })
        store.dispatch('utils/loaderMessage', '' )
      })
  },
  createUpdatePronostic({ commit, dispatch }, formData){
    let promise = null
    store.dispatch('utils/loaderMessage', 'Guardando pronóstico...' )
    commit('SET_LOADING', true)
    commit('SET_SUBMIT', true)
    if (formData.action === 'update'){
      promise = axios.put(JSON.parse(JSON.stringify(Object.fromEntries(formData.form))).url, formData.form, {
        headers: {'Content-Type': 'multipart/form-data' }
      })
    }else{
      promise = axios.post(appConfig.server_url + `/projects_management/project/`, formData.form, {
        headers: {'Content-Type': 'multipart/form-data' }
      })
    }
    promise.then((resp) => {
      commit('SET_SUBMIT', false)
      commit('SET_LOADING', false)
      store.dispatch('utils/loaderMessage', '' )
      dispatch('fetchPronostics', 'project_type=1')
      store.dispatch('utils/message', { type: 'success', title: 'Correcto', text: 'Pronóstico guardado correctamente.' })
    })
    .catch( error => {
      commit('SET_SUBMIT', false)
      commit('SET_LOADING', false)
      store.dispatch('utils/message', { type: 'error', title: 'Error', text: `${error}`})
      store.dispatch('utils/loaderMessage', '' )
    })
  },
  deletePronostic({ commit, dispatch }, payload) {
    commit('SET_SUBMIT', true)
    store.dispatch('utils/loaderMessage', 'Eliminando pronóstico...' )
    axios.delete(payload.url)
      .then(resp => {
        commit('SET_SUBMIT', false)
        store.dispatch('utils/message', { type: 'success', title: 'Correcto', text: 'Pronóstico eliminado correctamente.' })
        store.dispatch('utils/loaderMessage', '' )
        dispatch('fetchPronostics', 'project_type=1')
      })
      .catch( error => {
        commit('SET_SUBMIT', false)
        store.dispatch('utils/loaderMessage', '' )
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: `${error}`})
      })
  },
  fetchForecasters({ commit }, projectId) {
    commit('SET_LOADING', true)
    store.dispatch('utils/loaderMessage', 'Consultando orientadores...' )
    axios.get(appConfig.server_url + `/profile_management/profile/?project=${projectId}&role=2`)
      .then(resp => {
        commit('SET_PROJECT_FORECASTERS', resp.data)
        commit('SET_LOADING', false)
        store.dispatch('utils/loaderMessage', '' )
      })
      .catch(() => {
        commit('SET_LOADING', false)
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error consultando orientadores' })
        store.dispatch('utils/loaderMessage', '' )
      })
  },
  fetchProjects({ commit }, projectId) {
    commit('SET_LOADING', true)
    store.dispatch('utils/loaderMessage', 'Consultando proyectos...' )
    return axios.get(appConfig.server_url + (projectId ? `/projects_management/project/${projectId}/` :  `/projects_management/project/?project_type=1` ))
      .then(resp => {
        commit('SET_PROJECTS', resp.data)
        commit('SET_LOADING', false)
        store.dispatch('utils/loaderMessage', '' )
      })
      .catch(() => {
        commit('SET_LOADING', false)
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error consultando proyectos' })
        store.dispatch('utils/loaderMessage', '' )
      })
  },
  createForecaster({ commit, dispatch }, payload) {
    if (payload.user.password === null){
      delete payload.user.password
    }
    if (payload.birth_date === "" || payload.birth_date === null){
      delete payload.birth_date
    }  
    if (payload.gender === "" || payload.gender === null){
      delete payload.gender
    }    

    commit('SET_LOADING', true)
    store.dispatch('utils/loaderMessage', 'Creando orientador...' )
    axios.post(appConfig.server_url + '/profile_management/profile/', payload)
      .then(resp => {
        commit('SET_LOADING', false)
        store.dispatch('utils/message', { type: 'success', title: 'Correcto', text: 'Orientador creado correctamente.' })
        store.dispatch('utils/loaderMessage', '' )
        dispatch('fetchForecasters', payload.project_id)
      })
      .catch(() => {
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error creando Orientador' })
        store.dispatch('utils/loaderMessage', '' )
      })
  },
  updateForecaster({ commit, dispatch }, payload) {
    commit('SET_LOADING', true)
    store.dispatch('utils/loaderMessage', 'Actualizando orientador...' )
    axios.put(payload.url, payload)
      .then(resp => {
        commit('SET_LOADING', false)
        store.dispatch('utils/message', { type: 'success', title: 'Correcto', text: 'Orientador actualizado correctamente.' })
        store.dispatch('utils/loaderMessage', '' )
        dispatch('fetchForecasters', payload.project_id)
      })
      .catch(() => {
        commit('SET_LOADING', false)
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error actualizando orientador' })
        store.dispatch('utils/loaderMessage', '' )
      })
  },
  deleteForecaster({ commit, dispatch }, payload) {
    commit('SET_LOADING', true)
    store.dispatch('utils/loaderMessage', 'Eliminando Orientador...' )
    axios.delete(payload.url)
      .then(resp => {
        store.dispatch('utils/message', { type: 'success', title: 'Correcto', text: 'Orientador eliminado correctamente.' })
        store.dispatch('utils/loaderMessage', '' )
        commit('SET_LOADING', false)
        dispatch('fetchForecasters', payload.projectId)
      })
      .catch(() => {
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error eliminando Orientador' })
        store.dispatch('utils/loaderMessage', '' )
        commit('SET_LOADING', false)
      })
  },
  uploadFileForecaster({ commit, dispatch }, formData) {
    commit('SET_LOADING', true)
    store.dispatch('utils/loaderMessage', 'Subiendo archivo...' )
    return axios.post(appConfig.server_url + `/profile_management/create/users/${formData.projectId}/`, 
      formData.form, {
      headers: {
        'Content-Type': 'multipart/form-data' 
      }
    }).then((response) => {
        store.dispatch('utils/message', { type: 'success', title: 'Correcto', text: 'Archivo cargado correctamente.' })
        store.dispatch('utils/loaderMessage', '' )
        commit('SET_LOADING', false)
        commit('SET_CACHE', { key: 'uploadResult', value: response })
        store.dispatch('pronostics/fetchForecasters', formData.projectId)
      })
      .catch((response) => {
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error cargando archivo' })
        store.dispatch('utils/loaderMessage', '' )
        commit('SET_LOADING', false)
        commit('SET_CACHE', { key: 'uploadResult', value: response })
      })
  },
  cleanResult({ commit }){
    commit('SET_CACHE', { key: 'uploadResult', value: '' })
  },
  createEmail({ commit, dispatch }, payload) {
    commit('SET_LOADING', true)
    store.dispatch('utils/loaderMessage', 'Creando correo...' )
    return axios.post(appConfig.server_url + '/emails/email/', payload)
      .then(resp => {
        commit('SET_LOADING', false)
        store.dispatch('utils/message', { type: 'success', title: 'Correcto', text: 'Correo creado correctamente.' })
        store.dispatch('utils/loaderMessage', '' )
        store.dispatch('pronostics/fetchPronostics', 'project_type=1')
        return resp;
      })
      .catch(() => {
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error creando correo' })
        store.dispatch('utils/loaderMessage', '' )
      })
  },
  updateEmail({ commit, dispatch }, payload) {
    commit('SET_LOADING', true)
    store.dispatch('utils/loaderMessage', 'Actualizando correo...' )
    return axios.put(appConfig.server_url + payload.url, payload)
      .then(resp => {
        commit('SET_LOADING', false)
        store.dispatch('utils/message', { type: 'success', title: 'Correcto', text: 'Correo actualizado correctamente.' })
        store.dispatch('utils/loaderMessage', '' )
        store.dispatch('pronostics/fetchPronostics', 'project_type=1');
        return resp;
      })
      .catch(() => {
        commit('SET_LOADING', false)
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error actualizando Correo' })
        store.dispatch('utils/loaderMessage', '' )
      })
  },
  deleteEmail({ commit, dispatch }, payload) {
    commit('SET_LOADING', true)
    store.dispatch('utils/loaderMessage', 'Eliminando correo...' )
    axios.delete(appConfig.server_url + payload.url, payload)
      .then(resp => {
        commit('SET_LOADING', false)
        store.dispatch('utils/message', { type: 'success', title: 'Correcto', text: 'Correo eliminado correctamente.' })
        store.dispatch('utils/loaderMessage', '' )
        store.dispatch('pronostics/fetchPronostics', 'project_type=1')
      })
      .catch(() => {
        commit('SET_LOADING', false)
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error eliminando Correo' })
        store.dispatch('utils/loaderMessage', '' )
      })
  },
}
